import { axios } from '../utilities';

const addVersion = (version) => axios.post('api/versions', { version });

const getDataToCompareVersions = (projectId, chapterNumber) =>
  axios.get(`api/versions/projects/${projectId}/chapters/${chapterNumber}/data-to-compare`);

const restoreVersion = (versionId) => axios.post(`api/versions/restore/${versionId}`);

export default {
  addVersion,
  getDataToCompareVersions,
  restoreVersion,
};
